
import { Localization } from "@viamap/viamap2-common";
import React from "react";
import { ActionTracker } from "./ActionTracker";

export class TrackingErrorBoundary extends React.Component<{ children: React.ReactNode, location: string }, { hasError: boolean, message: string, stackTrace: string }> {
   constructor(props: { children: React.ReactNode, location: string }) {
      super(props);
      this.state = {
         hasError: false,
         message: "",
         stackTrace: ""
      };
   }

   static getDerivedStateFromError(error: Error) {
      return { hasError: true, message: error.message, stackTrace: error.stack || "" };
   }

   componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
      ActionTracker.track("Error", "ErrorBoundary", "Default", {
         ErrorLocation: this.props.location || undefined,
         ErrorMessage: error.message || undefined,
         StackTrace: error.stack || undefined,
         ComponentStack: errorInfo.componentStack || undefined,
      })
   }

   render() {
      if (this.state.hasError) {
         return <>
            <ADMErrorDisplay>
               <>
                  {Localization.getFormattedText("default.errorboundary.errorInfoMessage", { location: this.props.location })}
                  <br />
                  <br />
                  {Localization.getText("default.errorboundary.errorHelpMessage")}
                  <br />
               </>
            </ADMErrorDisplay>
         </>
      }
      return this.props.children;
   }
}

export function ADMErrorDisplay({ children }: { children: JSX.Element | string }) {
   return (
      <div className="ErrorDisplay">
         {children}
      </div>
   )
}